import { render, staticRenderFns } from "./UserStory.vue?vue&type=template&id=01b31db9&"
import script from "./UserStory.vue?vue&type=script&lang=js&"
export * from "./UserStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports